/**
 * 旅游（含子路由）
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/tour',
    component: () => import('@/views/tour/entry.vue'),
    children: [
      {
        path: '',
        name: 'tour_index',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/index.vue'
          ),
        meta: {
          title: '景点门票',
          is_festivalPop: true
        }
      },
      {
        path: '/tour/detail',
        name: 'tour_detail',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/detail.vue'
          ),
        meta: {
          title: '旅游详情'
        }
      },
      {
        path: '/tour/reserve',
        name: 'tour_reserve',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/reserve.vue'
          ),
        meta: {
          title: '预定'
        }
      },
      {
        path: '/tour/pay',
        name: 'tour_pay',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/pay.vue'
          ),
        meta: {
          title: '旅游收银台'
        }
      },
      {
        path: '/tour/searchResult',
        name: 'tour_searchResult',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/searchResult.vue'
          ),
        meta: {
          title: '景点搜索结果'
        }
      },
      {
        path: '/tour/order_detail',
        name: 'tour_order_detail',
        component: () =>
          import(
            /* webpackChunkName: "tour" */
            '@/views/tour/order_detail.vue'
          ),
        meta: {
          title: '订单详情'
        }
      }
    ]
  }
];
